module.exports = __webpack_public_path__ + "img/candidate.d1bbc769.png";